import i18n from '@/utils/i18n';
import { getRoomOrderStatusOptions, getOrderStatusOptions } from '@/api/order'
import { fetchCardTypeList } from '@/api/realTime.js'
const state = {
  roomOrderStatusOptions: [], // 房单状态枚举值
  orderStatusOptions: [], // 订单状态
  cardTypeList: [] // 证件类型
}
const mutations = {
  SET_ROOM_ORDER_STATUS(state, statusList) {
    state.roomOrderStatusOptions = statusList
  },
  SET_ORDER_STATUS(state, statusList) {
    state.orderStatusOptions = statusList
  },
  SET_CARD_LIST(state, statusList) {
    state.cardTypeList = statusList
  }
}
const actions = {
  async GET_ROOM_ORDER_STATUS({ commit, state }) {
    let roomOrderStatusList = state.roomOrderStatusOptions
    if (!roomOrderStatusList.length) {
      roomOrderStatusList = await new Promise(resolve => {
        getRoomOrderStatusOptions().then(res => {
          if (res.code === '0') {
            commit('SET_ROOM_ORDER_STATUS', res.data)
            resolve(res.data)
          }
        })
      })
    }
    return roomOrderStatusList
  },
  async GET_ORDER_STATUS({ commit, state }) {
    let orderStatusList = state.orderStatusOptions
    if (!orderStatusList.length) {
      orderStatusList = await new Promise(resolve => {
        getOrderStatusOptions().then(res => {
          if (res.code === '0') {
            commit('SET_ORDER_STATUS', res.data)
            resolve(res.data)
          }
        })
      })
    }
    return orderStatusList
  },
  async GET_CARD_LIST({ commit, state }) {
    let cardTypeList = state.cardTypeList
    if (!cardTypeList.length) {
      cardTypeList = await new Promise(resolve => {
        fetchCardTypeList().then(res => {
          if (res.code === '0') {
            commit('SET_CARD_LIST', res.data)
            resolve(res.data)
          }
        })
      })
    }
    return cardTypeList
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
